export const environment = {
  production: false,
  title: 'Autotest',
  // webPath: '/',
  // apiBaseURL: 'https://erp.whilli.com/api'
  webPath: '/',
  apiBaseURL: 'https://erp.gtp.bg/api'
};
